import { API_SCHOOL_URL } from '../config/config';

const API_BASE = API_SCHOOL_URL;

// export function getJobStatus(jobId) {
//   return axios.get(`${API_BASE}/jobs/${jobId}`);
// }

// Opens an SSE connection for live progress. Returns the EventSource so the
// caller can close it (e.g. on unmount).
export function subscribeToJob(jobId, { onProgress, onDone, onError }) {
  const source = new EventSource(`${API_BASE}/jobs/${jobId}/stream`, { withCredentials: true });

  source.onmessage = (evt) => {
    const data = JSON.parse(evt.data);
    if (data.type === 'progress') onProgress?.(data);
    if (data.type === 'done') onDone?.(data);
    if (data.type === 'error') onError?.(data);
  };

  source.onerror = () => {
    // EventSource auto-retries; surface a soft error but don't kill it ourselves
    onError?.({ message: 'Connection to progress stream interrupted, retrying…', transient: true });
  };

  return source;
}